// extracted by mini-css-extract-plugin
export default {"root":"_1-S12","icon":"lKwfi","dropdown":"_11vDo"};